import { Sparkles, Cpu, Globe, Moon, Waves, Code2, PenTool, BookOpen, Binary, FileText, BarChart3, Languages, MessageSquare, Camera } from "lucide-react";

export const PROVIDER_META = {
  openai: {
    icon: Sparkles,
    color: "text-emerald-400",
    badge: "bg-emerald-500/10 text-emerald-300 border-emerald-500/30",
    glow: "shadow-[0_0_24px_rgba(16,185,129,0.15)]",
    ring: "border-emerald-500/50",
    dot: "bg-emerald-400",
  },
  anthropic: {
    icon: Cpu,
    color: "text-amber-400",
    badge: "bg-amber-500/10 text-amber-300 border-amber-500/30",
    glow: "shadow-[0_0_24px_rgba(245,158,11,0.15)]",
    ring: "border-amber-500/50",
    dot: "bg-amber-400",
  },
  gemini: {
    icon: Globe,
    color: "text-cyan-400",
    badge: "bg-cyan-500/10 text-cyan-300 border-cyan-500/30",
    glow: "shadow-[0_0_24px_rgba(6,182,212,0.15)]",
    ring: "border-cyan-500/50",
    dot: "bg-cyan-400",
  },
  moonshot: {
    icon: Moon,
    color: "text-purple-400",
    badge: "bg-purple-500/10 text-purple-300 border-purple-500/30",
    glow: "shadow-[0_0_24px_rgba(168,85,247,0.15)]",
    ring: "border-purple-500/50",
    dot: "bg-purple-400",
  },
  deepseek: {
    icon: Waves,
    color: "text-sky-400",
    badge: "bg-sky-500/10 text-sky-300 border-sky-500/30",
    glow: "shadow-[0_0_24px_rgba(56,189,248,0.15)]",
    ring: "border-sky-500/50",
    dot: "bg-sky-400",
  },
};

export const CATEGORY_ICONS = { Code2, PenTool, BookOpen, Binary, FileText, BarChart3, Languages, MessageSquare, Camera };

export const modelsForKind = (provider, kind) => provider.models.filter((m) => m.kind === kind);

export const findModel = (catalog, providerId, modelId) =>
  catalog?.providers.find((p) => p.id === providerId)?.models.find((m) => m.id === modelId);

export const findProvider = (catalog, providerId) => catalog?.providers.find((p) => p.id === providerId);

export const findCategory = (catalog, categoryId) => catalog?.categories.find((c) => c.id === categoryId);
